<div class="densest">
  <div>
    <label class="text-input-label" for="{{ id }}"
      >{{ label }}<span *ngIf="required"> *</span></label
    >
  </div>
  <mat-form-field appearance="outline" class="text-input-form-field">
    <input
      matInput
      [id]="id"
      [placeholder]="placeholder"
      [formControl]="control"
      [type]="type"
      [mask]="mask"
      [readonly]="isReadOnly"
      [pattern]="pattern"
      [min]="min"
      [max]="max"
      [step]="step"
      [attr.aria-describedby]="describedBy || null"
    />
    <mat-icon
      class="text-input-icon"
      matSuffix
      *ngIf="this.control.status == 'INVALID' && this.control.touched"
      >error_outline</mat-icon
    >
    <mat-error>{{ errorText }}</mat-error>
  </mat-form-field>
</div>
